import { Type } from '@angular/core'

/**
 * @description Used as a base component to make an instance of all Component in a Generic way
 * @see ./zone.component.ts
 */
export class BaseComponent {
  constructor(public component: Type<any>) {}
}
